module.exports = __webpack_public_path__ + "static/media/esqui-randone.61baad94.jpg";